import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { AuthState } from "@/redux/slice/auth/types/AuthState";
import fetchUserType from "@/redux/slice/auth/thunks/fetchUserType";
import { ThunkResolvedStatus } from "@/libs/enum/ThunkResolvedStatus";

const fetchUserTypeBuilder = (builder: ActionReducerMapBuilder<AuthState>): void => {
  builder
    .addCase(fetchUserType.pending, (state) => {
      state.thunkStatus.fetchUserType = ThunkResolvedStatus.pending;
    })
    .addCase(fetchUserType.fulfilled, (state, action) => {
      const userType = action?.payload;

      if (userType) {
        state.thunkStatus.fetchUserType = ThunkResolvedStatus.fulfilled;
        state.userType = userType;
      }
    })
    .addCase(fetchUserType.rejected, (state) => {
      state.thunkStatus.fetchUserType = ThunkResolvedStatus.rejected;
    });
};

export default fetchUserTypeBuilder;
